import { useQuery } from '@tanstack/react-query';
import { LabTest } from '../schemas/shared/lab';
import useApi from './useApi';

type AppointmentLabTestsProps = {
  apptId: number | null;
  surveyEventCode: string;
};

const LAB_ROUTE_BY_EVENT = {
  LABH: 'HOME_TEST_KIT',
  LABP: 'IN_PERSON'
} as const;

type RandoxSurveyEvent = keyof typeof LAB_ROUTE_BY_EVENT;

const useRandoxSurveyLabTests = ({ apptId, surveyEventCode }: AppointmentLabTestsProps) => {
  const { Api } = useApi();

  const isRandoxSurvey = LAB_ROUTE_BY_EVENT.hasOwnProperty(surveyEventCode);

  const { data = null } = useQuery<LabTest | null>({
    queryKey: ['AppointmentLabTests', apptId, surveyEventCode],
    queryFn: async () => {
      const response = await Api.labs.getLabs({
        appt_id: apptId,
        order_route_code: LAB_ROUTE_BY_EVENT[surveyEventCode as RandoxSurveyEvent]
      });

      return response?.labs[0] || null;
    },
    enabled: !!apptId && isRandoxSurvey
  });

  return data;
};

export default useRandoxSurveyLabTests;
